import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import api from '../api/api';

const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];

export default function User() {
  const [years, setYears]           = useState([]);
  const [year, setYear]             = useState('');
  const [quarter, setQuarter]       = useState('');
  const [vendorCode, setVendorCode] = useState('');
  const [panNumber, setPanNumber]   = useState('');
  const [message, setMessage]       = useState('');
  const [loading, setLoading]       = useState(false);
  const navigate = useNavigate();
  const { instance } = useMsal();
  const user = JSON.parse(sessionStorage.getItem('user') || '{}');

  const handleLogout = () => {
    sessionStorage.clear();
    const isMock = !instance.getActiveAccount();
    if (isMock) { window.location.href = '/'; } else { instance.logoutRedirect({ postLogoutRedirectUri: '/' }); }
  };

  useEffect(() => { api.get('/user/years').then(r => setYears(r.data)).catch(() => {}); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    if (!vendorCode) { setMessage('Enter Vendor/Dealer/Supplier/Depositor Code'); return; }
    if (!panNumber)  { setMessage('Enter PAN Number'); return; }
    if (!year)       { setMessage('Select Year'); return; }
    if (!quarter)    { setMessage('Select Quarter'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/user/get-form16', { vendorCode, panNumber, year, quarter });
      if (data.status === 'notpublished') { setMessage('PDF not uploaded for this period'); return; }
      if (data.status === 'invalid')      { setMessage('Invalid Vendor/Dealer/Supplier code or PAN'); return; }
      if (data.status === 'notavailable') { setMessage('PAN number not updated on system'); return; }
      if (data.status === 'notfound')     { setMessage('PDF not found'); return; }
      window.open(data.pdfUrl, '_blank');
    } catch (err) { setMessage(err.response?.data?.error || 'Request failed'); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <img src="/godrej-logo-dark.svg" alt="Godrej" style={s.logo} />
        <span style={s.headerTitle}>Form 16A</span>
        <div style={s.headerRight}>
          <span style={s.userLabel}>{user.loginName}</span>
          <button style={s.logoutBtn} onClick={handleLogout}>Logout</button>
        </div>
      </div>

      <div style={s.body}>
        <div style={s.card}>
          <h3 style={s.sectionTitle}>Download Form 16A</h3>
          <form onSubmit={handleSubmit}>
            <div style={s.row}>
              <div style={s.field}>
                <label style={s.label}>Financial Year</label>
                <select style={s.select} value={year} onChange={e => setYear(e.target.value)}>
                  <option value="">-- Select --</option>
                  {years.map(y => <option key={y.Year} value={y.Year}>{y.Year}</option>)}
                </select>
              </div>
              <div style={s.field}>
                <label style={s.label}>Quarter</label>
                <select style={s.select} value={quarter} onChange={e => setQuarter(e.target.value)} disabled={!year}>
                  <option value="">-- Select --</option>
                  {QUARTERS.map(q => <option key={q} value={q}>{q}</option>)}
                </select>
              </div>
            </div>
            <div style={s.field}>
              <label style={s.label}>Vendor / Dealer / Supplier Code</label>
              <input style={s.input} value={vendorCode} onChange={e => setVendorCode(e.target.value)} />
            </div>
            <div style={s.field}>
              <label style={s.label}>PAN Number</label>
              <input style={s.input} value={panNumber} onChange={e => setPanNumber(e.target.value.toUpperCase())} maxLength={10} />
            </div>
            {message && <p style={s.msgBox}>{message}</p>}
            <button style={s.btn} type="submit" disabled={loading}>
              {loading ? 'Searching...' : 'Get Form 16A'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:        { minHeight: '100vh', background: '#fafafa' },
  header:      { height: '56px', padding: '0 2rem', display: 'flex', alignItems: 'center', gap: '1rem', borderBottom: '1px solid #F1F1ED', background: '#fff' },
  logo:        { height: '28px' },
  headerTitle: { fontFamily: 'var(--font-headline)', fontSize: '1.1rem', color: '#333', flex: 1 },
  headerRight: { display: 'flex', alignItems: 'center', gap: '12px' },
  userLabel:   { fontSize: '14px', color: 'var(--brand-grey)' },
  logoutBtn:   { background: 'transparent', border: '1px solid var(--brand-purple)', color: 'var(--brand-purple)', padding: '4px 14px', cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '13px', borderRadius: '50px' },
  body:        { padding: '24px', maxWidth: '500px', margin: '0 auto' },
  card:        { background: '#fff', padding: '24px', border: '1px solid #F1F1ED' },
  sectionTitle:{ margin: '0 0 16px', fontFamily: 'var(--font-headline)', color: '#333', fontWeight: 'normal' },
  row:         { display: 'flex', gap: '16px', flexWrap: 'wrap' },
  field:       { flex: 1, minWidth: '140px', marginBottom: '14px' },
  label:       { display: 'block', fontSize: '13px', color: 'var(--brand-grey)', marginBottom: '4px' },
  select:      { width: '100%', height: '50px', padding: '0 10px', border: '1px solid #F1F1ED', fontSize: '14px', color: 'var(--brand-grey)' },
  input:       { width: '100%', height: '50px', padding: '0 15px', border: '1px solid #F1F1ED', fontSize: '16px', color: 'var(--brand-grey)', outline: 'none' },
  msgBox:      { padding: '8px 12px', background: '#fdecea', color: '#c62828', fontSize: '13px', marginBottom: '12px', borderRadius: '2px' },
  btn:         { width: '80%', padding: '0.6rem', background: 'var(--brand-purple)', color: '#fff', border: 'none', fontFamily: 'var(--font-highlight)', fontSize: '0.9rem', cursor: 'pointer', borderRadius: '50px', display: 'block', margin: '0 auto' },
};
